import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import './PocetnaChooser.css';

const PocetnaChooser = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const planNovi = useSelector(state => state.planNovi || 0);
    const token = useSelector(state => state.user?.token);

    // Desk Access je zasebna aplikacija (nije deo TMS routera). Otvara se u
    // novom tabu; TMS token prosleđujemo kroz #hash (ne u query — ne ide na
    // server niti u logove), pa operater ne mora ponovo da se loguje.
    const otvoriDeskAccess = () => {
        const bazni = process.env.REACT_APP_DESK_URL
            || ((process.env.REACT_APP_BACKEND_URL || '').includes('localhost')
                ? 'http://localhost:4100/desk'
                : '/desk');
        const url = `${bazni}/operater.html${token ? '#token=' + encodeURIComponent(token) : ''}`;
        window.open(url, '_blank', 'noopener');
    };

    return (
        <div className="pocetna-chooser">
            <h1 className="pocetna-title">{t('home.izaberiModul')}</h1>
            <div className="pocetna-cards">
                <button className="pocetna-card pocetna-card-taskovi" onClick={() => history.push('/tabla_zaduzenja')}>
                    {planNovi > 0 && (
                        <span className="pocetna-badge" title="Novi tiketi">{planNovi > 99 ? '99+' : planNovi}</span>
                    )}
                    <i className="pi pi-check-square" />
                    <span className="pocetna-card-title">{t('home.taskovi')}</span>
                    <span className="pocetna-card-sub">{t('home.taskoviOpis')}</span>
                </button>
                <button className="pocetna-card pocetna-card-beleznica" onClick={() => history.push('/beleznica/unos')}>
                    <i className="pi pi-book" />
                    <span className="pocetna-card-title">{t('home.beleznica')}</span>
                    <span className="pocetna-card-sub">{t('home.beleznicaOpis')}</span>
                </button>
                <button className="pocetna-card pocetna-card-desk" onClick={otvoriDeskAccess}>
                    <i className="pi pi-desktop" />
                    <span className="pocetna-card-title">{t('home.deskAccess')}</span>
                    <span className="pocetna-card-sub">{t('home.deskAccessOpis')}</span>
                </button>
            </div>
        </div>
    );
};

export default PocetnaChooser;
